import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import searchControl from './app/search-control.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';


import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


class ScrollReveal {
  constructor(options){
    this.options = options;
  }

  reveal(el, options, duration){
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire( el, function(){
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options,args);
      anime(args);
    }, {
      offset: window.innerHeight - 100
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.searchControl = new searchControl();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        if ($('.js-mv-slider').find('.c-block-mv-slider__block').length < 3 && window.innerWidth > 750){
          $('.js-mv-slider').toggleClass('owl-carousel');
          return false;
        } else if($('.js-mv-slider').find('.c-block-mv-slider__block').length < 2 && window.innerWidth <= 750) {
          $('.js-mv-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-mv-slider').owlCarousel({
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 800,
          dotsSpeed: 800,
          navSpeed: 800,
          dragEndSpeed: 800,
          autoWidth: false,
          autoHeight: false,
          onInitialized: heightRemove,
          navText: ['<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-black-prev.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-white-prev.png" /><img class="is-sp" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-white-prev-sm.svg" />', '<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-black-next.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-white-next.png" /><img class="is-sp" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-white-next-sm.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 18,
              stagePadding: 80,
              center: true,
            },
            // breakpoint from 750 up
            750: {
              items: 2,
              margin: 33,
              stagePadding: 180,
              center: false,
            },
            950: {
              items: 2,
              margin: 33,
              stagePadding: 322,
              center: false,
            },
            1600: {
              items: 3,
              margin: 33,
              stagePadding: 322,
              center: false,
            }
          }
        });
        function heightRemove() {
          $('.c-block-mv-slider').css('height','auto');
        }
      });
      //->スライダー
      owls.imagesLoaded(function () {
        if ($('.js-projects-slider').children().length < 4 && window.innerWidth > 750){
          $('.js-projects-slider').toggleClass('owl-carousel');
          return false;
        } else if($('.js-projects-slider').children().length < 2 && window.innerWidth <= 750) {
          $('.js-projects-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-projects-slider').owlCarousel({
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 800,
          dotsSpeed: 800,
          navSpeed: 800,
          dragEndSpeed: 800,
          autoWidth: false,
          autoHeight: false,
          navText: ['<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-black-prev.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-white-prev.png" />', '<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-black-next.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-white-next.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 18,
              stagePadding: 36,
              center: true,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
              margin: 36,
              stagePadding: 0,
              center: true,
            },
          }
        });
      });
      //->スライダー
      owls.imagesLoaded(function () {
        if ($('.js-products-slider').children().length < 4 && window.innerWidth > 750){
          $('.js-products-slider').toggleClass('owl-carousel');
          return false;
        } else if ($('.js-products-slider').children().length < 2 && window.innerWidth <= 750){
          $('.js-products-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-products-slider').owlCarousel({
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 800,
          dotsSpeed: 800,
          navSpeed: 800,
          dragEndSpeed: 800,
          autoWidth: false,
          autoHeight: false,
          center: true,
          onInitialized: activeRefresh,
          onTranslated: activeRefresh,
          navText: ['<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-prev.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-white-prev.png" />', '<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-next.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-white-next.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 19,
              stagePadding: 56,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
              margin: 36,
              stagePadding: 180,
            },
            1000: {
              items: 3,
              margin: 55,
              stagePadding: 242,
            },
            1600: {
              items: 5,
              margin: 55,
              stagePadding: 242,
            }
          }
        });
        function activeRefresh() {
          let $allItem = $('.owl-item');
          let $center = $('.owl-item.center');
          let $next = $center.nextAll('.owl-item:first');
          let $prev = $center.prevAll('.owl-item:first');
          let addClassName = 'active';

          if (window.innerWidth >= 750) {
            $allItem.removeClass(addClassName);
            $center.addClass(addClassName);
            $next.addClass(addClassName);
            $prev.addClass(addClassName);

            if (window.innerWidth >= 1600) {
              $next.next().addClass(addClassName);
              $prev.prev().addClass(addClassName);
            }
          }
        }
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-card-slider').find('.c-card__block').length < 3){
          $('.js-card-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 800,
          dotsSpeed: 800,
          navSpeed: 800,
          dragEndSpeed: 800,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }
    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'easeInCubic';
      var baseDistance = '10';

      sr.reveal(".c-block-case-category__inner", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-front-about", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-front-service", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-front-products", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-front-news", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-mission__inner", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-strength__block", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-center__blocks", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-initiatives", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-main-visual-projects", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-projects-gallery__lead", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-projects-gallery", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-projects-details", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-related-products", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
      sr.reveal(".c-block-projects", {
        duration: 300,
        opacity: [0, 1],
        delay: 0,
        easing: baseEasing,
      }, 100);
    }



    // slick
    function slickSlider() {

      if ($('.js-gallery-main').children().length < 0 ){
        return false;
      }

      if ($('.js-gallery-thumbnail').children().length < 4 && window.innerWidth > 750) {
        $(".js-gallery-thumbnail").addClass("is-simple-center");
      }

      if ($('.js-gallery-thumbnail').children().length <= 4 && window.innerWidth <= 750) {
        $(".js-gallery-thumbnail").addClass("is-transition-none");
      }

      if ($('.js-gallery-thumbnail').children().length < 2) {
        $(".js-gallery-thumbnail").addClass("is-simple-none");
      }

      // 上段
      $('.js-gallery-main').slick({
        infinite: true,
        arrow: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.js-gallery-thumbnail',
        autoplaySpeed: 3000,
        speed: 800,
        autoplay: false,
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1
          }
        }]
      });

      // 下段
      $('.js-gallery-thumbnail').slick({
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 800,
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: '24.128%',
        asNavFor: '.js-gallery-main',
        prevArrow: '<div class="slick-prev"><img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-prev.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-white-prev.png" /></div>',
        nextArrow: '<div class="slick-next"><img src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-next.png" /><img class="is-hover" src="/wp-content/themes/lighting-sou-html/dist/assets/images/icon-slider-blue-white-next.png" /></div>',
        focusOnSelect: true,
        centerMode: true,
        variableWidth: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 3000,
            slidesToShow: 4,
            centerPadding: false,
            centerMode: false,
          }
        }]
      });
    }



    function searchOpen() {
      $('.l-header__search-btn').on('click', function () {
        $('.l-header__search').toggleClass('is-active');
        setTimeout(function() {
          $('.l-header__search-input input').get(0).focus();
        }, 300);
      });

      // 要素以外をクリックした時に閉じる
      $(document).on('click', function(e) {
        if(!$(e.target).closest('.l-header__search').length) {
          $('.l-header__search').removeClass('is-active');
        }
      });
    }

    function activeButton() {
      const targetBtn = $('.js-active-btn');
      const targetBtnLg = $('.js-active-btn-lg');
      targetBtn.on('click', function(e) {
        $(this).toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
          $(this).text('保存リストに追加済');
        } else {
          $(this).text('保存リストに追加');
        }
        e.preventDefault();
      });
      targetBtnLg.on('click', function(e) {
        $(this).toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
          $(this).find('span').text('この製品を保存リストに追加済');
        } else {
          $(this).find('span').text('この製品を保存リストに追加');
        }
        e.preventDefault();
      });
    }

    function productSlickSlider() {

      $('.js-slider-main').each(function (i, elm) {
        let $slider_area = $(elm).parent();
        let $main_slide = $slider_area.find(".js-slider-main");
        let $thumb_slide = $slider_area.find(".js-thumb");


        // データ属性の数字を割り振る
        $thumb_slide.find('.js-thumb-item').each(function () {
          let index = $thumb_slide.find('.js-thumb-item').index(this);
          $(this).attr("data-index", index);
        });

        // 初期化
        $main_slide.on('init', function (slick) {
          $thumb_slide.find(".js-thumb-item:first-child").addClass('thumb-current');
        });

        // サムネイルをクリックした時スライダー切り替え
        $thumb_slide.find(".js-thumb-item").on('click', function () {
          let index = $(this).attr("data-index");
          $main_slide.slick("slickGoTo", index, false);
        });

        // サムネイル画像のカレントを切り替え
        $main_slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $thumb_slide.find(".js-thumb-item").removeClass("thumb-current");
          $thumb_slide.find('.js-thumb-item[data-index="' + nextSlide + '"]').addClass("thumb-current");
        });

        // オプション
        $main_slide.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          accessibility: false,
          dots: false,
          arrows: false,
          fade: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {}
            },
          ]
        });
      });
    }

    function deleteItem() {
      const deleteBtn = $('.js-delete');

      deleteBtn.on('click', function() {
        $(this).parents('.js-wrapper').fadeOut();
      });
    }

    function animationTrigger() {
      let $mv =  $('.c-main-visual');
      let $header =  $('.l-header');
      let $slidebarBtn =  $('.c-slidebar-button');

      $(window).on('load', () => {
        $mv.addClass('is-animating');
        $slidebarBtn.addClass('is-animating');
        if ($header.hasClass('is-special')) {
          $header.addClass('is-animating');
        } else {
          $header.css({
            'opacity': 1,
            'transition': 'none',
          });
        }
      });
    }

    // 詳細検索　特徴から探す
    function allSelect() {
      const triggerBtn = $('.js-allSelect').find('.all');
      const allBtn = $('.js-allSelect').find('input');
      triggerBtn.on('change',function() {
        if ($(this).prop('checked')) {
          allBtn.prop('checked', true);
        } else {
          allBtn.prop('checked', false);
        }
      });
    }


    $(function () {
      owlCarousel();
      reveal();
      slickSlider();
      searchOpen();
      // activeButton();
      productSlickSlider();
      deleteItem();
      animationTrigger();
      allSelect();
    });
  }
}

window.GApp = new App();
